/*
  POS price filter for Boost collection and search cards.
  Boost builds card prices from all variants, including POS-only variants (title contains "(POS)").
  This recalculates price_min / price_max / compare_at_price from web variants only, before the card is built.
  Loaded after boost-pfs-filter.js (see snippets/boost-pfs.liquid).
*/
(function () {
  if (typeof BoostPFS === 'undefined') return;
  BoostPFS.inject(this);

  function isPos(v) {
    return v && typeof v.title === 'string' && v.title.indexOf('(POS)') !== -1;
  }

  function toNum(x) {
    var n = parseFloat(x);
    return isNaN(n) ? null : n;
  }

  function adjust(data) {
    if (!data || !data.variants || !data.variants.length) return data;
    var web = data.variants.filter(function (v) { return !isPos(v); });
    if (!web.length || web.length === data.variants.length) return data;

    var min = null, max = null, cmin = null, cmax = null;
    web.forEach(function (v) {
      var p = toNum(v.price);
      var c = toNum(v.compare_at_price);
      if (p !== null) {
        if (min === null || p < min) min = p;
        if (max === null || p > max) max = p;
      }
      if (c !== null && c > 0) {
        if (cmin === null || c < cmin) cmin = c;
        if (cmax === null || c > cmax) cmax = c;
      }
    });
    if (min === null) return data;

    // Safety check: web prices must sit inside the product's overall price range.
    // If they don't, the variant prices are in different units, so leave the card untouched.
    var oMin = toNum(data.price_min), oMax = toNum(data.price_max);
    if (oMin !== null && oMax !== null && (min < oMin - 0.001 || max > oMax + 0.001)) return data;

    data.price_min = min;
    data.price_max = max;
    data.compare_at_price_min = cmin !== null ? cmin : 0;
    data.compare_at_price_max = cmax !== null ? cmax : 0;
    return data;
  }

  function wrap(Cls) {
    if (!Cls || !Cls.prototype || typeof Cls.prototype.compileTemplate !== 'function') return;
    var original = Cls.prototype.compileTemplate;
    Cls.prototype.compileTemplate = function (data) {
      if (!data) data = this.data;
      return original.call(this, adjust(data));
    };
  }

  if (typeof ProductGridItem !== 'undefined') wrap(ProductGridItem);
  if (typeof ProductListItem !== 'undefined') wrap(ProductListItem);
})();
